export default "__VITE_ASSET__DI646dt$__"